'use strict';

var REVIEW_MESSAGE_SELECTOR = '.js-pdp-review-message';
var ACTIVE_CLASS = 'show';

function init() {
   var reviewMessageEl = document.querySelector(REVIEW_MESSAGE_SELECTOR);
   var timeoutDelay = SitePreferences.PDP_REVIEW_MESSAGE_DELAY || 4000;

   if (reviewMessageEl) {
      setTimeout(function() {
         reviewMessageEl.classList.remove(ACTIVE_CLASS);
      }, timeoutDelay);
   }
}

module.exports = {
   init: init
};
